module.exports = __webpack_public_path__ + "static/img/product14.d1b4a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product14.png
// module id = JQsY
// module chunks = 10